const listCustomLayoutStyle = (theme) => ({
    mainContainer: {
        '&:not(:first-child)': {
            marginTop: '50px',
        },
    },
    listTitleLiveStream: {
        padding: '5px 0 9px 10px',
        backgroundColor: (props) => props?.customColor?.list_table?.title_background_color || '#939caa',
    },
    listTitle: {
        marginTop: '50px',
        padding: '5px 0 9px 10px',
        backgroundColor: (props) => props?.customColor?.list_table?.title_background_color || '#939caa',
    },
    dividerUp: {
        margin: '15px 15px 5px 15px',
    },
    dividerDown: {
        margin: '0px 15px 5px 15px',
        color: '#ddd',
    },
    listInfoEvent: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    listTimeLeft: {
        marginBottom: '5px',
        display: 'flex',
        flexWrap: 'wrap',
    },
    listTimeLeftDate: {
        marginRight: '13px',
    },
    listButton: {
        display: 'flex',
        justifyContent: 'end',
    },
    listStatusRight: {
        fontWeight: 'normal',
        minWidth: '105px',
        '& > span': {
            display: 'block',
            backgroundColor: (props) => props?.customColor?.background_color_status_live_seminar || '#ffcccc',
            padding: '0px 20px',
        },
    },
    listImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    listItemImg: {
        position: 'relative',
        display: 'block',
        overflow: 'hidden',
        borderBottom: '1px solid rgba(0,0,0,0.2)',

        '&:before': {
            display: 'block',
            paddingTop: '137%',
            content: '" "',
        },
    },
    paddingBottom: {
        paddingBottom: '15px',
    },
    listImgLeft: {
        alignItems: 'end',
    },
    listProfile: {
        alignItems: 'end',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },
    },
    listPrice: {
        fontWeight: 'normal',
        '& > span': {
            display: 'block',
            backgroundColor: (props) => props?.customColor?.background_color_price_live_seminar || '#ddeaf6',
            padding: '0px 20px',
        },
    },
    listProfileRight: {
        position: 'static',
        paddingLeft: '0px',

        '@media (max-width: 680px)': {
            position: 'static',
            paddingLeft: '0px',
            paddingRight: '0px',
        },
    },
    listPriceRight: {
        display: 'flex',
        justifyContent: 'end',
        [theme.breakpoints.down('xs')]: {
            paddingBottom: '10px',
        },
    },
    listProfileName: {
        position: 'absolute',
        top: '20%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',

        '@media (max-width: 350px)': {
            position: 'absolute',
            top: '0%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '-webkit-line-clamp': 1,
            '-webkit-box-orient': 'vertical',
            display: '-webkit-box',
        },
    },
    listProfileSpeaker: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',

        '@media (max-width: 680px)': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
            display: '-webkit-box',
            lineHeight: 1,
        },
    },
    listReadMore: {
        justifyContent: 'center',
    },
    listReadMoreButton: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '20px',
        cursor: 'pointer',
    },
    listContent: {
        marginTop: '20px',
    },
    listFullName: {
        marginTop: '20px',
        marginBottom: '20px',
    },
    cursor: {
        cursor: 'pointer',
    },
    textPrice: {
        fontWeight: 'normal',
    },
    textPriceDisable: {
        fontWeight: 'normal',
        color: 'rgba(0, 0, 0, 0.34);',
    },
});

export default listCustomLayoutStyle;
